import { useAuth } from "../context/AuthContext";
import logo from "../assets/logo.png";

const Topbar = () => {
  const { user, logout } = useAuth();

  return (
    <div className="topbar">
      {/* LEFT */}
      <div className="topbar-left">
        <img src={logo} alt="Logo" className="topbar-logo" />
        <span className="topbar-title">Croplyra Billing</span>
      </div>

      {/* RIGHT */}
      <div className="topbar-right">
        <div className="user-info">
          <span className="user-name">{user?.full_name}</span>
          <span className="user-role">{user?.role}</span>
        </div>

        <button className="logout-btn" onClick={logout}>
          Logout
        </button>
      </div>
    </div>
  );
};

export default Topbar;
